import React, { useState } from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { useHistory } from "react-router-dom";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";

import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { ForgetPassword } from "../../../fetchs";

import { withRouter } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";

import Modal from "@material-ui/core/Modal";
// import { makeStyles } from "@material-ui/core/styles";

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
  },
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  paper1: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

function SimpleModal(props) {
  const classes = useStyles();
  // const history = useHistory();
  const [pass, setPass] = useState("");
  const [openModal, setopenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openState, setOpenState] = useState(false);
  const history = useHistory();

  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = React.useState(getModalStyle);

  const handleOpen = () => {
    setopenModal(true);
  };

  const handleClose = () => {
    setopenModal(true);
  };

  const body = (
    <div style={modalStyle} className={classes.paper1}>
      <h2 id='simple-modal-title'>
        رمز عبور جدید برای شما به شماره تماس ارسال شد
      </h2>
      {/* <p id='simple-modal-description'>{pass}</p> */}

      <Link to='/login'>
        <Button
          color='primary'
          className='btn btn-info btn-lg'
          id='regProdbtn'
          //   onClick={() => {
          //     setId(item.id);
          //   }}
        >
          تایید
        </Button>
      </Link>

      {/* <SimpleModal /> */}
    </div>
  );

  function handleSubmit(e) {
    e.preventDefault();
    if (e.target.phoneNumber.value === "") {
      toast.error("شماره تماس وارد نشده است");
      return false;
    }

    ForgetPassword(e.target.phoneNumber.value)
      .then((response) => {
        if (response.status === 200) {
          setopenModal(true);
        }
        return response.json();
      })
      .then((responseJson) => {
        // setPass(responseJson.result);
        // history.push("/login");
      })
      .catch((error) => {
        console.log(error);
        toast.error("خطای ارتباط با سرور");
        return false;
      });
  }

  return (
    <Container component='main' maxWidth='xs'>
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component='h1' variant='h5'>
          فراموشی رمز عبور
        </Typography>
        <form className={classes.form} noValidate onSubmit={handleSubmit}>
          <TextField
            variant='outlined'
            margin='normal'
            required
            fullWidth
            id='phoneNumber'
            label='شماره تماس'
            name='phoneNumber'
            autoComplete='phoneNumber'
            autoFocus
          />

          <div className={classes.wrapper}>
            <Button
              type='submit'
              fullWidth
              variant='contained'
              color='primary'
              className={classes.submit}
              disabled={loading}
            >
              ارسال
            </Button>
            {loading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </div>

          <div>
            {/* <button type='button' onClick={handleOpen}>
                    Open Modal
                  </button> */}
            <Modal
              open={openModal}
              onClose={handleClose}
              aria-labelledby='simple-modal-title'
              aria-describedby='simple-modal-description'
            >
              {body}
            </Modal>
          </div>
        </form>
      </div>
    </Container>
  );
}
export default withRouter(SimpleModal);
